/* eslint-disable handle-callback-err */
import axios from 'axios';
import _ from 'lodash';
import * as actionTypes from './actionTypes';
import { axiosPayLoad } from './reducer';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import {
  handleExistingCommentList,
  getRandomNumberByInput,
  handleQuarterFormate,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

export const dispatchGetCodeTableDetails = (data) => ({
  type: actionTypes.GET_NDCs_LIST_SEARCH_BY_NAME_OR_NDCs,
  drugsList: data,
});

export const getModalCodeTableDetails = (data) => ({
  type: actionTypes.GET_NDCs_LIST_MODAL_SEARCH_BY_NAME_OR_NDCs,
  drugsModalList: data,
});

export const updateFetchedNDCsValue = (value) => (dispatch) => {
  dispatch(dispatchGetCodeTableDetails(value));
};

export const dispatchGetExNDCsExtraState = (data) => ({
  type: actionTypes.EXCLUDED_NDCS_EXTRA_STATE,
  extraState: data,
});
export const setExNDCsExtraState = (value) => (dispatch) => {
  dispatch(dispatchGetExNDCsExtraState(value));
};

export const dispatchExcludedNDCsSearch = (data) => ({
  type: actionTypes.GET_EXCLUDED_NDC_SEARCH,
  searchValue: data,
});

export const dispatchCommonDropdownData = (data) => ({
  type: actionTypes.GET_COMMON_DROPDOWN_DATA,
  dropdown: data,
});

export const dispatchAllManufacturerList = (data) => ({
  type: actionTypes.GET_ALL_MANUFATURERE_LIST,
  allManufacturer: data,
});

export const dispatchAllLabelerList = (data) => ({
  type: actionTypes.GET_ALL_LABELER_LIST,
  allLabeler: data,
});

export const dispatchNDcsListByManufacturer = (data) => ({
  type: actionTypes.GET_NDCS_LIST_BY_MANUFACTURERS,
  ndcsDetailList: data,
});

export const dispatchSaveExcludedNDCs = (data) => ({
  type: actionTypes.SAVE_EXCLUDED_NDC,
  saveNDC: data,
});

export const dispatchExcludedNDCsSearchTable = (data) => ({
  type: actionTypes.SEARCH_TABLE_ACTION,
  searchTable: data,
});

export const dispatchExcludedNDCsSearchTableList = (data) => ({
  type: actionTypes.SEARCH_TABLE_NDCS_LIST,
  ndcsList: data,
});

export const excludedNDCsModalSearchTableList = (data) => ({
  type: actionTypes.MODAL_SEARCH_TABLE_NDCS_LIST,
  ndcsListForModal: data,
});

export const dispatchExcludedNDCsErrorMsgList = (data) => ({
  type: actionTypes.EXCLUDED_NDCS_ERROR_MSG,
  errorMessages: data,
});

export const dispatchViewHistoryforPlan = (data) => ({
  type: actionTypes.VIEW_HISTORY,
  ndcsHistory: data,
});

export const saveExcludedNDCsSearch = (value) => (dispatch) => {
  dispatch(dispatchExcludedNDCsSearch(value));
};

export const saveExcludedNDCsErrorMsgList = (value) => (dispatch) => {
  dispatch(dispatchExcludedNDCsErrorMsgList(value));
};

export const saveExcludedNDCsSearchTable = (value) => (dispatch) => {
  dispatch(dispatchExcludedNDCsSearchTable(value));
};

export const saveExcludedNDCsTableList = (value) => (dispatch) => {
  dispatch(dispatchExcludedNDCsSearchTableList(value));
};

const checkCommentInList = async (data, dispatch, storeRedux) => {
  const newData = {
    orgList: [],
    updatedList: [],
    deletedList: [],
  };
  if (data) {
    newData.orgList = !_.isEmpty(data.orgList)
      ? await handleExistingCommentList(data.orgList, null, 'allList')
      : [];
    newData.updatedList = !_.isEmpty(data.updatedList)
      ? await handleExistingCommentList(data.updatedList, null, 'allList')
      : [];
    newData.deletedList = !_.isEmpty(data.deletedList)
      ? await handleExistingCommentList(data.deletedList, null, 'allList')
      : [];
  }
  return dispatch(storeRedux(newData));
};

export const saveExcludedNDCsDetailList = (value) => (dispatch) => {
  checkCommentInList(value, dispatch, dispatchNDcsListByManufacturer);
  // dispatch(dispatchNDcsListByManufacturer(value));
};

export const dispatchUpdateNDcsListByAgGrid = (data) => ({
  type: actionTypes.UPDATE_NDCS_LIST_VALUE_UNDER_AG_GRID,
  ndcsDetailList: data,
});
export const originalExistingNDCList = (data) => ({
  type: actionTypes.EXISTING_NDC_LIST,
  existingNDCOriginalList: data,
});
export const updateExcludedNDCsDetailList = (value) => (dispatch) => {
  // const updatedList = !_.isEmpty(value.updatedList)
  //     ? await handleExistingCommentList(value.updatedList, null, 'allList')
  //     : [];
  handleExistingCommentList(value, dispatch, dispatchUpdateNDcsListByAgGrid);
  // dispatch(dispatchUpdateNDcsListByAgGrid(value));
};

export const getCommonDropdownList = (value) => {
  return axios
    .post(serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN, { planType: value })
    .then((response) => {
      return response.data;
      // return dispatch(dispatchCommonDropdownData(response.data));
    })
    .catch((response) => {
      return [];
      // dispatch(dispatchCommonDropdownData([]));
    });
};

export const getNDCsListSearchByNameorNDCs =
  (values, existingLabelerList) => (dispatch) => {
    const filter = {
      searchBy: values.searchBy,
      inputValue: values.inputValue,
      page: values.page,
      pageSize: values.pageSize,
    };
    let url = serviceEndPoint.SEARCH_NDC_BY_ID_OR_DRUG_NAME;
    if (values.selection === 'Existing Rows') {
      filter.rebateProgramControl = values.rebateProgramControl;
      url = serviceEndPoint.SEARCH_EXISTING_NDC_BY_ID_OR_DRUG_NAME;
    }
    return axios
      .post(url, filter)
      .then((response) => {
        let resultList = { ...response.data };
        if (existingLabelerList?.length > 0 && resultList?.data?.length > 0) {
          resultList = {
            ...resultList,
            data: resultList?.data?.map((item) => {
              const obj = existingLabelerList.filter((x) => {
                return x.drugSeqNum === item.drugSeqNum;
              });
              return obj?.length > 0
                ? {
                    ...obj[0],
                    productCode: item.productCode,
                    packageSize: item.packageSize,
                    labelerCode: item.labelerCode,
                    drugName: item.drugName,
                  }
                : item;
            }),
          };
          dispatch(originalExistingNDCList(existingLabelerList));
        } else {
          dispatch(originalExistingNDCList(resultList?.data));
        }
        if (values.pageFor === 'detailFilter') {
          dispatch(getModalCodeTableDetails(response.data));
        } else {
          dispatch(dispatchGetCodeTableDetails(resultList));
        }
      })
      .catch((error) => {
        if (values.pageFor === 'detailFilter') {
          dispatch(getModalCodeTableDetails({ error: 'API failed' }));
        } else {
          dispatch(dispatchGetCodeTableDetails({ error: 'API failed' }));
        }
      });
  };
export const getExistingLabelerList = (values, searchBy) => {
  let filter = {};
  if (searchBy === 'labeler') {
    filter.searchBy = 'labelor';
    filter.inputValue = values.labelerCode;
    filter.rebateProgramControl = values.rebateProgramControl;
  } else {
    filter = {
      searchBy: values?.searchBy,
      inputValue: values?.inputValue,
      rebateProgramControl: values?.rebateProgramControl,
      page: values?.page,
      pageSize: values?.pageSize,
    };
  }
  return axios
    .post(serviceEndPoint.SEARCH_EXISTING_NDC_BY_ID_OR_DRUG_NAME, filter)
    .then((response) => {
      return response.data && response.data?.data;
    })
    .catch(() => {
      return [];
    });
};

export const getNDCsListSearchByNLabeler =
  (values, existingLabelerList) => (dispatch) => {
    const filter = {};
    let url = serviceEndPoint.LIST_DRUG_FOR_LABELERS;
    if (values.selection === 'Existing Rows') {
      filter.searchBy = 'labelor';
      filter.inputValue = values.labelerCode;
      filter.rebateProgramControl = values.rebateProgramControl;
      url = serviceEndPoint.SEARCH_EXISTING_NDC_BY_ID_OR_DRUG_NAME;
    } else {
      filter.labelerCode = values.labelerCode;
      filter.page = values.page;
      filter.pageSize = values.pageSize;
    }
    return axios
      .post(url, filter)
      .then((response) => {
        let resultList = { ...response.data };
        if (existingLabelerList?.length > 0 && resultList?.data?.length > 0) {
          resultList = {
            ...resultList,
            data: resultList?.data?.map((item) => {
              const obj = existingLabelerList.filter((x) => {
                return x.drugSeqNum === item.drugSeqNum;
              });
              return obj?.length > 0
                ? {
                    ...obj[0],
                    productCode: item.productCode,
                    packageSize: item.packageSize,
                    labelerCode: item.labelerCode,
                    drugName: item.drugName,
                  }
                : item;
            }),
          };
          dispatch(originalExistingNDCList(existingLabelerList));
        } else {
          dispatch(originalExistingNDCList(resultList?.data));
        }
        if (values.pageFor === 'detailFilter') {
          dispatch(getModalCodeTableDetails(response.data));
        } else {
          dispatch(dispatchGetCodeTableDetails(resultList));
        }
      })
      .catch((error) => {
        if (values.pageFor === 'detailFilter') {
          dispatch(getModalCodeTableDetails({ error: 'API failed' }));
        } else {
          dispatch(dispatchGetCodeTableDetails({ error: 'API failed' }));
        }
      });
  };

export const getAllManufacturerList = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.EXISTING_NDC_LABELERS_LIST, values)
    .then((response) => {
      dispatch(dispatchAllManufacturerList(response.data));
    })
    .catch((error) => {
      dispatch(dispatchAllManufacturerList({ error: 'API failed' }));
    });
};

export const updateAllLabelerList = (value) => (dispatch) => {
  dispatch(dispatchAllLabelerList(value));
};

export const getAllLabelerList = (values) => (dispatch) => {
  const filter = {};
  if (values.selection === 'Existing Rows') {
    filter.rebateProgramControl = values.rebateProgramControl;
    return axios
      .post(serviceEndPoint.EXISTING_NDC_LABELERS_LIST, filter)
      .then((response) => {
        dispatch(dispatchAllLabelerList(response.data));
      })
      .catch((error) => {
        dispatch(dispatchAllLabelerList({ error: 'API failed' }));
      });
  }
  return axios
    .get(serviceEndPoint.NDC_LABELERS_LIST, filter)
    .then((response) => {
      dispatch(dispatchAllLabelerList(response.data));
    })
    .catch((error) => {
      dispatch(dispatchAllLabelerList({ error: 'API failed' }));
    });
};

export const getNDCsLidtByManufacturers = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.EXISTING_NDC_BY_LABELERS, value)
    .then((response) => {
      const data = { orgList: [], updatedList: [] };
      if (
        response.data &&
        response.data.message === 'SUCESS' &&
        response.data.status === '001'
      ) {
        let list = [];
        if (!_.isEmpty(response.data.data)) {
          list = _.map(response.data.data, (item) => {
            const val = _.cloneDeep(item);
            const listIndex = getRandomNumberByInput(1)[0];
            val.listIndex = listIndex;
            val.oldStartQtr = val.startQtr;
            val.oldEndQtr = val.endQtr;
            val.lastUpdateDt = val?.lastUpdateDt || null;
            val.endQtr =
              val.endQtr === '99994' || val.endQtr === '4Q9999'
                ? ''
                : val.endQtr;
            return val;
          });
        }
        data.orgList = _.cloneDeep(list);
        data.updatedList = _.cloneDeep(list);
      }
      dispatch(saveExcludedNDCsDetailList(data));
    })
    .catch((error) => {
      dispatch(dispatchNDcsListByManufacturer({ error: 'API failed' }));
    });
};

export const updateCodeTableDetails =
  (values, getNDCsTableListRedux, actionType) => (dispatch, getState) => {
    const getOriginalExistingNDCList = [
      ...getState().sharedState.ExcludedNDCsReducer?.existingNDCOriginalList,
    ];
    return axios
      .post(serviceEndPoint.SAVE_EXCLUDED_NDC, values)
      .then((response) => {
        const tempObj =
          response.data && response.data.data?.saveExcludedNDCVOList;
        const NDCLeft = getNDCsTableListRedux?.ndcsLeft?.map((item) => {
          if (
            tempObj?.filter(
              (x) =>
                x.drugSeqNum === item.drugSeqNum &&
                (actionType === 'Any Rows' && !item?.excludedNdcSeqNum
                  ? true
                  : x?.excludedNdcSeqNum === item?.excludedNdcSeqNum)
            )?.length > 0
          ) {
            const obj = tempObj?.filter(
              (x) =>
                x.drugSeqNum === item.drugSeqNum &&
                (actionType === 'Any Rows' && !item?.excludedNdcSeqNum
                  ? true
                  : x?.excludedNdcSeqNum === item?.excludedNdcSeqNum)
            )[0];

            item.oldStartQtr = item.startQtr;
            item.oldEndQtr = item.endQtr;
            item.endQtr =
              obj.endQtr === '99994' || obj.endQtr === '4Q9999'
                ? ''
                : handleQuarterFormate(obj?.endQtr);
            item.startQtr = handleQuarterFormate(obj?.startQtr);
          }
          return item;
        });
        const NDCRight = getNDCsTableListRedux?.ndcsRight?.map((item) => {
          if (
            tempObj?.filter(
              (x) =>
                x.drugSeqNum === item.drugSeqNum &&
                (actionType === 'Any Rows' && !item?.excludedNdcSeqNum
                  ? true
                  : x?.excludedNdcSeqNum === item?.excludedNdcSeqNum)
            )?.length > 0
          ) {
            const obj = tempObj?.filter(
              (x) =>
                x.drugSeqNum === item.drugSeqNum &&
                (actionType === 'Any Rows' && !item?.excludedNdcSeqNum
                  ? true
                  : x?.excludedNdcSeqNum === item?.excludedNdcSeqNum)
            )[0];
            item.oldStartQtr = item.startQtr;
            item.oldEndQtr = item.endQtr;
            item.endQtr =
              obj.endQtr === '99994' || obj.endQtr === '4Q9999'
                ? ''
                : handleQuarterFormate(obj?.endQtr);
            item.startQtr = handleQuarterFormate(obj?.startQtr);
          }
          return item;
        });
        if (getOriginalExistingNDCList?.length > 0) {
          const newObj = getOriginalExistingNDCList?.map((item) => {
            if (
              tempObj?.filter(
                (x) =>
                  x.drugSeqNum === item.drugSeqNum &&
                  (actionType === 'Any Rows' && !item?.excludedNdcSeqNum
                    ? true
                    : x?.excludedNdcSeqNum === item?.excludedNdcSeqNum)
              )?.length > 0
            ) {
              const obj = tempObj?.filter(
                (x) =>
                  x.drugSeqNum === item.drugSeqNum &&
                  (actionType === 'Any Rows' && !item?.excludedNdcSeqNum
                    ? true
                    : x?.excludedNdcSeqNum === item?.excludedNdcSeqNum)
              )[0];
              item.oldStartQtr = item.startQtr;
              item.oldEndQtr = item.endQtr;
              item.endQtr =
                obj.endQtr === '99994' || obj.endQtr === '4Q9999'
                  ? ''
                  : handleQuarterFormate(obj?.endQtr);
              item.startQtr = handleQuarterFormate(obj?.startQtr);
            }
            return item;
          });
          dispatch(originalExistingNDCList(newObj));
        }
        dispatchExcludedNDCsSearchTableList({
          ...getNDCsTableListRedux,
          ndcsLeft: NDCLeft?.length > 0 ? NDCLeft : [],
          ndcsRight: NDCRight?.length > 0 ? NDCRight : [],
        });

        dispatch(dispatchSaveExcludedNDCs(response.data));
      })
      .catch((error) => {
        // dispatch(dispatchSaveExcludedNDCs(error.response.data));
        dispatch(dispatchSaveExcludedNDCs([error]));
      });
  };

export const getNDCsHistory = (values) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.VIEW_HISTORY}`, values)
    .then((response) => {
      return dispatch(
        dispatchViewHistoryforPlan(
          response.data && response.data.responseAuditLogDetails
        )
      );
    })
    .catch((response) => {
      dispatch(dispatchViewHistoryforPlan([]));
    });
};

export const setFilterAndSortForTable = (val) => {
  return { type: actionTypes.FILTER_AND_SORT_FOR_EXCLUDED_NDC, payload: val };
};

export const clearExcludedNDCPageDispatch = (val) => {
  return { type: actionTypes.CLEAR_EXCLUDED_NDCS_REDUX_DATA, payload: val };
};

export const clearExcludedNDCsPage = () => (dispatch, getState) => {
  const reduxObj = getState()?.sharedState?.ExcludedNDCsReducer;
  const updateTabs =
    JSON.parse(localStorage.getItem('tabItemsData')) === null
      ? []
      : JSON.parse(localStorage.getItem('tabItemsData'));
  let newObj1 = {};
  if (!_.isEmpty(updateTabs)) {
    const newObj = _.cloneDeep(reduxObj);
    if (
      updateTabs.filter(
        (x) => x.navTo === '/excludedNDCs' || x.navTo === '/excludedNDCsDetail'
      ).length !== 0
    ) {
      newObj1 = newObj;
      if (
        updateTabs.filter((x) => x.navTo === '/excludedNDCsDetail').length === 0
      ) {
        newObj1 = {
          ...newObj1,
          ndcsDetailList: [],
        };
      }
    } else {
      newObj1 = { ...axiosPayLoad };
    }
  } else {
    newObj1 = { ...axiosPayLoad };
  }

  dispatch(clearExcludedNDCPageDispatch(newObj1));
};
